<div style="position: relative" class="d-flex justify-content-center mt-2">
  <nz-spin *ngIf="isLoading" [nzSize]="'large'" class="spinner-table"></nz-spin>

  <nz-table
    #headerTable
    [nzData]="responseData"
    nzBordered
    nzTableLayout="fixed"
    [nzFrontPagination]="false"
    [nzScroll]="isDesktop ? { x: '', y: '' } : { x: '1150px', y: '400px' }">
    <thead>
      <tr>
        <ng-container *ngFor="let column of visibleColumns">
          <th
            [nzLeft]="(isMobile || isTablet) && column.title == 'Utenti'"
            [nzSortFn]="column.compare ? column.compare : null"
            [nzShowSort]="!!column.compare"
            [nz-tooltip]="column.tooltip"
            (click)="onSort({ key: column.title, value: sortValue })"
            onkeydown=""
            [id]="column.title"
            class="table-header-bg text-start p-2 py-3">
            {{ column.title }}
          </th>
        </ng-container>
      </tr>
    </thead>

    <tbody [ngStyle]="{ opacity: isLoading ? 0 : 1 }">
      <tr *ngFor="let data of headerTable.data" class="text-center">
        <td [nzLeft]="isMobile || isTablet" class="text-start fw-bolder">
          {{ data.Nome }}
        </td>
        <td class="fw-bolder">{{ data.StoryPoint }}</td>
        <td class="fw-bolder">{{ data.OreStimate }}</td>
        <td class="fw-bolder">{{ data.OreEffettive }}</td>
        <td
          class="fw-bolder"
          [ngClass]="{
            'text-danger': data.DiscostamentoDalleStime > 20,
            'text-success': data.DiscostamentoDalleStime <= 20
          }">
          {{ data.DiscostamentoDalleStime }}%
          <ng-container *ngIf="data?.DiscostamentoDalleStime !== null">
            <img
              *ngIf="
                data?.DiscostamentoDalleStime > 20 ||
                data?.DiscostamentoDalleStime < -20
              "
              src="./assets/images/Shared/down.png"
              class="arrow"
              alt="down icon" />
            <img
              *ngIf="
                data?.DiscostamentoDalleStime >= -20 &&
                data?.DiscostamentoDalleStime < 0
              "
              src="./assets/images/Shared/up.png"
              class="arrow"
              alt="up icon" />
            <img
              *ngIf="
                data?.DiscostamentoDalleStime >= 0 &&
                data?.DiscostamentoDalleStime <= 20
              "
              src="./assets/images/Shared/up.png"
              class="arrow"
              alt="up icon" />
          </ng-container>
        </td>
        <td class="fw-bolder">{{ data.Capacity }}</td>
        <td class="fw-bolder">{{ data.Velocity }}</td>
        <td
          *ngIf="isMonitoringPage"
          class="fw-bolder"
          [ngClass]="{
            'text-danger': data.DeltaVel < 0,
            'text-success': data.DeltaVel >= 0
          }">
          {{ data.DeltaVel }}%
          <img
            [src]="
              data.DeltaVel < 0
                ? './assets/images/Shared/down.png'
                : './assets/images/Shared/up.png'
            "
            class="arrow"
            alt="" />
        </td>
        <td *ngIf="isMonitoringPage" class="fw-bolder">{{ data.Successo }}%</td>
        <td
          *ngIf="isMonitoringPage"
          class="fw-bolder"
          [ngClass]="{
            'text-danger': data.DeltaSuccesso < 0,
            'text-success': data.DeltaSuccesso >= 0
          }">
          {{ data.DeltaSuccesso }}%

          <img
            [src]="
              data.DeltaSuccesso < 0
                ? './assets/images/Shared/down.png'
                : './assets/images/Shared/up.png'
            "
            class="arrow"
            alt="" />
        </td>

        <td
          *ngIf="!isMonitoringPage"
          class="fw-bolder"
          [ngClass]="{
            'text-danger': data.MediaResiduo > 20,
            'text-success': data.MediaResiduo <= 20
          }">
          {{ data.MediaResiduo }}%
          <img
            [src]="
              data.MediaResiduo > 20
                ? './assets/images/Shared/down.png'
                : './assets/images/Shared/up.png'
            "
            class="arrow"
            alt="" />
        </td>

        <td *ngIf="!isMonitoringPage">
          <div
            class="d-flex align-items-center justify-content-around"
            *ngIf="data.Progetti.length <= 2">
            <img
              *ngFor="let project of data.Progetti.slice(0, 2)"
              [src]="sanitizeImage(project.filestorage_path)"
              [alt]=""
              class="logo-project"
              [nz-tooltip]="project.alias" />
          </div>
          <div
            class="d-flex align-items-center justify-content-around"
            *ngIf="data.Progetti.length >= 3">
            <img
              *ngFor="let project of data.Progetti.slice(0, 1)"
              [src]="sanitizeImage(project.filestorage_path)"
              [alt]=""
              class="logo-project"
              [nz-tooltip]="project.alias" />
            <p
              nz-dropdown
              [nzDropdownMenu]="projectUserMenu"
              nzTrigger="click"
              class="mb-0 plus-font fw-bold fs-4 logo-project cursor-pointer">
              +
            </p>
            <nz-dropdown-menu #projectUserMenu="nzDropdownMenu">
              <ul nz-menu>
                <li nz-menu-item *ngFor="let project of data.Progetti.slice(1)">
                  {{ project.alias }}
                </li>
              </ul>
            </nz-dropdown-menu>
          </div>
        </td>

        <td class="fw-bolder">{{ data.NumeroDiSprint }}</td>
      </tr>
    </tbody>

    <ng-container *ngIf="responseData.length > 0">
      <tfoot>
        <tr>
          <td [nzLeft]="isMobile || isTablet" class="text-start fw-bolder">
            Totale
          </td>
          <td class="text-center">
            <b>{{ responseTotal?.StoryPoint }}</b>
          </td>

          <td class="text-center">
            <b>{{ responseTotal?.OreStimate }}</b>
          </td>

          <td class="text-center">
            <b>{{ responseTotal?.OreEffettive }}</b>
          </td>
          <td
            class="text-center"
            [ngClass]="{
              'text-danger': responseTotal?.DiscostamentoDalleStime > 20,
              'text-success': responseTotal?.DiscostamentoDalleStime <= 20
            }">
            <b> {{ responseTotal?.DiscostamentoDalleStime }}%</b>
            <ng-container
              *ngIf="responseTotal?.DiscostamentoDalleStime !== null">
              <img
                *ngIf="
                  responseTotal?.DiscostamentoDalleStime > 20 ||
                  responseTotal?.DiscostamentoDalleStime < -20
                "
                src="./assets/images/Shared/down.png"
                class="arrow"
                alt="down icon" />
              <img
                *ngIf="
                  responseTotal?.DiscostamentoDalleStime >= -20 &&
                  responseTotal?.DiscostamentoDalleStime < 0
                "
                src="./assets/images/Shared/up.png"
                class="arrow"
                alt="up icon" />
              <img
                *ngIf="
                  responseTotal?.DiscostamentoDalleStime >= 0 &&
                  responseTotal?.DiscostamentoDalleStime <= 20
                "
                src="./assets/images/Shared/up.png"
                class="arrow"
                alt="up icon" />
            </ng-container>
          </td>

          <td class="text-center">
            <b>{{ responseTotal?.Capacity }}</b>
          </td>

          <td class="text-center">
            <b>{{ responseTotal?.Velocity }} </b>
            <i *ngIf="selectedProject.length > 0" class="text-secondary">
              ({{ totAziendali.Velocity }})</i
            >
          </td>

          <td
            class="text-center"
            *ngIf="responseTotal?.DeltaVel !== '0.00' && isMonitoringPage"
            [ngClass]="{
              'text-danger': responseTotal?.DeltaVel < 0,
              'text-success': responseTotal?.DeltaVel >= 0
            }">
            <b>{{ responseTotal?.DeltaVel }}%</b>
            <img
              [src]="
                responseTotal?.DeltaVel < 0
                  ? './assets/images/Shared/down.png'
                  : './assets/images/Shared/up.png'
              "
              class="arrow"
              alt="" />
          </td>

          <td
            class="text-center"
            *ngIf="responseTotal?.DeltaVel == '0.00' && isMonitoringPage"
            [ngClass]="{
              'text-danger': responseTotal?.DeltaVel < 0,
              'text-success': responseTotal?.DeltaVel >= 0
            }"></td>

          <td class="text-center" *ngIf="isMonitoringPage">
            <b> {{ responseTotal?.PercentualeSuccesso }}% </b>
            <i *ngIf="selectedProject.length > 0" class="text-secondary">
              ({{ totAziendali.SuccessoRispettoAlleOreDiCapacity }})</i
            >
          </td>

          <td
            *ngIf="isMonitoringPage"
            class="text-center"
            [ngClass]="{
              'text-success': responseTotal?.DeltaSuccesso > 0,
              'text-danger': responseTotal?.DeltaSuccesso < 0
            }">
            <b *ngIf="responseTotal?.DeltaSuccesso !== '0.00'"
              >{{ responseTotal?.DeltaSuccesso }}%</b
            >
            <img
              *ngIf="responseTotal?.DeltaSuccesso !== '0.00'"
              [src]="
                responseTotal?.DeltaSuccesso < 0
                  ? './assets/images/Shared/down.png'
                  : './assets/images/Shared/up.png'
              "
              class="arrow"
              alt="" />
          </td>
          <td *ngIf="isMonitoringPage"></td>

          <td
            class="text-center fw-bolder"
            *ngIf="!isMonitoringPage"
            [ngClass]="{
              'text-danger': responseTotal?.PercentualeResiduoTotale > 20,
              'text-success': responseTotal?.PercentualeResiduoTotale <= 20
            }">
            {{ responseTotal?.PercentualeResiduoTotale }}%
            <img
              [src]="
                responseTotal?.PercentualeResiduoTotale > 20
                  ? './assets/images/Shared/down.png'
                  : './assets/images/Shared/up.png'
              "
              class="arrow"
              alt="" />
          </td>
          <td *ngIf="!isMonitoringPage"></td>
          <td *ngIf="!isMonitoringPage"></td>
        </tr>
      </tfoot>
    </ng-container>
  </nz-table>
</div>

<nz-pagination
  class="d-flex justify-content-end align-items-center"
  [ngStyle]="{ opacity: isLoading ? 0 : 1 }"
  [nzSize]="'small'"
  [nzPageSize]="pageSize"
  [nzTotal]="totUserForPage"
  (nzPageIndexChange)="onPageChange($event)"
  (nzPageSizeChange)="onPageSizeChange($event)"
  [nzPageSizeOptions]="[5, 10, 25, 100]"
  nzShowSizeChanger
  [nzShowTotal]="totalSondaggiTemplate"></nz-pagination>

<ng-template #totalSondaggiTemplate let-range="range" let-total
  >{{ range[0] }}-{{ range[1] }} di {{ total }} utenti</ng-template
>
